import React from "react";

import { ColorModeContext } from "../../../../App";
import { styled, useTheme } from "@mui/material/styles";
import MuiAppBar from "@mui/material/AppBar";
import { IconButton, Slide, Toolbar, Typography, useScrollTrigger } from "@mui/material";

import MenuIcon from "@mui/icons-material/Menu";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import LoginIcon from "@mui/icons-material/Login";
import LogoutIcon from "@mui/icons-material/Logout";

import CustomButton from "../../../../helper-components/input/CustomButton";
import { logUserOut } from "../../../../helper-functions/api/authQueries.js";
import { useLanguage } from "../../../../config/language/language.js";
import * as Constants from "../../../../config/constants/Constants.js";

const StyledAppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open"
})(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
    }),
    ...(open && {
        marginLeft: Constants.PAGE_DRAWER_WIDTH_PX,
        width: `calc(100% - ${Constants.PAGE_DRAWER_WIDTH_PX}px)`,
        transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        })
    })
}));

export default function Appbar(props) {
    const isMobile = props.browser.isMobile;
    const theme = useTheme();
    const colorMode = React.useContext(ColorModeContext);
    const LANG = useLanguage();
    const trigger = useScrollTrigger();

    const venue =
        props.prefs?.guestPrefs?.venue || props.auth.authStatus?.venue || props.menu.menuData?.venue;
    const isLoggedIn = props.user.isLoggedIn;

    return (
        <Slide appear={false} direction="down" in={!trigger}>
            <StyledAppBar position="fixed" open={props.sidebar.openAppDrawer && !isMobile}>
                <Toolbar sx={{ pr: "24px" }}>
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        onClick={props.sidebar.toggleAppDrawer}
                        sx={{
                            marginRight: isMobile ? "12px" : "36px",
                            ...(props.sidebar.openAppDrawer && !isMobile && { display: "none" })
                        }}>
                        <MenuIcon />
                    </IconButton>

                    <Typography component="h1" variant="h5" color="inherit" noWrap sx={{ flexGrow: 1 }}>
                        {LANG.TOOLBAR_TITLE}
                        {venue ? ` · ${venue}` : ""}
                    </Typography>

                    <IconButton sx={{ ml: 0.5 }} onClick={colorMode.toggleColorMode} color="inherit">
                        {theme.palette.mode === "dark" ? <Brightness7Icon /> : <Brightness4Icon />}
                    </IconButton>

                    {isLoggedIn ? (
                        <CustomButton {...props} title={LANG.BUTTON_SIGNOUT} icon={<LogoutIcon />} onClick={() => logUserOut(props)} variant="text" color="inherit" />
                    ) : (
                        <CustomButton
                            {...props}
                            title={LANG.BUTTON_SIGNIN}
                            icon={<LoginIcon />}
                            onClick={() => props.browser.navigate("/login")}
                            variant="text"
                            color="inherit"
                        />
                    )}
                </Toolbar>
            </StyledAppBar>
        </Slide>
    );
}
